import routineReducerFactory from './routineReducerFactory';
import { fetchProductSuppliers } from '../actions/routines';

const productSuppliers = routineReducerFactory(fetchProductSuppliers, {
    data: [],
});

export default productSuppliers;
